module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/1-b4688d2c06409bbf55dc7e6414d3edc3.svg";